<template>
  <v-app>
    <v-container fluid class="py-0 px-3 customer-enquiry">
      <v-row>
        <!-- Form -->
        <v-col lg="6" md="8" sm="12" class="mx-auto">
          <div class="bg-white rounded-lg">
            <div
              class="header-details d-flex align-center justify-space-between flex-wrap px-4 py-3"
            >
              <!-- Left: Logo -->
              <div>
                <img
                  style="width: 140px; max-width: 100%"
                  :src="companyLogo"
                  alt="Company Logo"
                />
              </div>

              <!-- Right: Customer Info -->
              <div class="customer-info text-right mt-3 mt-md-0">
                <div class="customer-name">
                  <v-icon small class="mr-1">mdi-account</v-icon>
                  {{ customer.name || "-" }}
                </div>

                <div class="customer-meta">
                  <v-icon small class="mr-1">mdi-email</v-icon>
                  {{ customer.email || "-" }}
                </div>

                <div class="customer-meta">
                  <v-icon small class="mr-1">mdi-phone</v-icon>
                  {{ customer.phone || "-" }}
                </div>
              </div>
            </div>
            <div class="pa-6">
              <v-card
                flat
                outlined
                class="rounded-lg mb-4"
                color="grey lighten-4"
              >
                <v-card-text class="px-5 py-4">
                  <h6 class="text-h6 font-weight-bold">Basic Details</h6>
                  <!-- Enquiry Title -->
                  <v-label class="required">Enquiry Title</v-label>
                  <v-text-field
                    v-model="form.title"
                    placeholder="Enquiry Title"
                    dense
                    solo
                    rounded
                    flat
                    color="cyan"
                    class="rounded-field mb-4"
                    :error="!form.title"
                  />
                  <v-label class="black--text">Description</v-label>
                  <v-textarea
                    rounded
                    class="rounded-field"
                    v-model="form.description"
                    placeholder="Description"
                    auto-grow
                    dense
                    solo
                    flat
                    color="cyan"
                    rows="2"
                    @keypress="(e) => manageLimit(e, 'description')"
                    @paste="(e) => onPaste(e, 'description')"
                  />
                  <div class="d-flex justify-end">
                    {{ form.description.length }}/100
                  </div>

                  <v-label class="black--text">Problem Statement</v-label>
                  <v-textarea
                    class="rounded-field"
                    v-model="form.problem"
                    placeholder="Problem Statement"
                    auto-grow
                    dense
                    solo
                    flat
                    rows="2"
                    color="cyan"
                    @keypress="(e) => manageLimit(e, 'problem')"
                    @paste="(e) => onPaste(e, 'problem')"
                  />
                  <div class="d-flex justify-end">
                    {{ form.problem.length }}/100
                  </div>

                  <div v-if="isCustomerType" class="mt-4">
                    <div class="d-flex align-center justify-space-between mb-4 flex-wrap">
                      <v-label class="black--text">Line Items</v-label>
                      <v-btn
                        color="cyan"
                        class="custom-bold-button white--text"
                        @click="dialog_key = Number(new Date()); product_dialog = true"
                      >
                        <v-icon class="mr-2">mdi-plus</v-icon>
                        Customer Asset
                      </v-btn>
                    </div>

                    <!-- Selected Line Items Table -->
                    <div v-if="selectedLineItems.length" class="custom-grey-border">
                      <div class="d-flex grey lighten-4">
                        <div
                          class="color-custom-blue py-2 font-weight-700 text-left"
                          style="width: 65%"
                        >
                          Customer Asset
                        </div>
                        <div
                          class="color-custom-blue py-2 font-weight-700 px-2 line-item-qty-label"
                          style="width: 20%"
                        >
                          Quantity
                        </div>
                        <div
                          class="color-custom-blue py-2 font-weight-700"
                          style="width: 15%"
                        ></div>
                      </div>
                              <div class="line-item-list">
                                <div
                                  v-for="(item, index) in selectedLineItems"
                                  :key="`line-item-${index}`"
                                >
                                  <div class="d-flex py-1 border-bottom align-center line-item-row">
                          <div
                            class="text-left px-2 line-item-title-cell"
                            style="width: 65%"
                          >
                            <div class="d-flex align-center line-item-title-main">
                              <v-avatar size="32" class="mr-2">
                                <img
                                  v-if="item?.image?.url"
                                  :src="item?.image?.url"
                                  :alt="item?.product"
                                />
                                <img v-else src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ctext x='12' y='12' text-anchor='middle' dominant-baseline='central' font-size='14'%3E?%3C/text%3E%3C/svg%3E" />
                              </v-avatar>
                              <div style="flex: 1; min-width: 0">
                                <div class="selected-asset-label text-truncate">
                                  {{ getLineItemLabel(item) }}
                                </div>
                              </div>
                              <div class="line-item-actions line-item-actions-mobile">
                                <v-btn
                                  icon
                                  color="cyan"
                                  @click="item._expanded = !item._expanded"
                                  :title="item._expanded ? 'Collapse' : 'Expand description'"
                                >
                                  <v-icon>{{ item._expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                </v-btn>

                                <v-btn
                                  icon
                                  color="red lighten-1"
                                  @click="removeLineItem(index)"
                                  :title="'Remove item'"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </div>
                            </div>
                            <div
                              class="d-flex flex-wrap align-center ml-0 mt-1 line-item-meta-mobile"
                              v-if="item.barcode || item.serial_no"
                            >
                              <v-chip
                                v-if="item.barcode"
                                label
                                color="chip-custom-blue"
                                outlined
                                x-small
                                class="text-white px-1 mr-1 mb-1"
                                style="font-weight: 700"
                              >
                                {{ item.barcode }}
                              </v-chip>
                              <v-chip
                                v-if="item.serial_no"
                                label
                                color="#f4c542"
                                text-color="#3b2f00"
                                outlined
                                x-small
                                class="px-1 mb-1"
                                style="font-weight: 700"
                              >
                                {{ item.serial_no }}
                              </v-chip>
                            </div>
                          </div>
                          <div
                            class="text-center px-2 line-item-qty"
                            style="width: 20%"
                          >
                            <v-text-field
                              v-model.number="item.quantity"
                              class="line-item-header-text px-0"
                              placeholder="Qty"
                              dense
                              filled
                              solo
                              flat
                              type="number"
                              min="1"
                              color="cyan"
                            />
                          </div>
                            <div
                              class="font-weight-600 text-center d-flex align-center justify-center line-item-actions line-item-actions-desktop"
                              style="width: 15%"
                            >
                              <v-btn
                                icon
                                color="cyan"
                                @click="item._expanded = !item._expanded"
                                :title="item._expanded ? 'Collapse' : 'Expand description'"
                              >
                                <v-icon>{{ item._expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                              </v-btn>

                              <v-btn
                                icon
                                color="red lighten-1"
                                @click="removeLineItem(index)"
                                :title="'Remove item'"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </div>

                          <div v-if="item._expanded" class="px-3 py-3 border-bottom">
                            <TinyMCE v-model="item.description" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="custom-border-top p-3">
                      <p
                        class="m-0 p-4 font-size-16 font-weight-500 light-gray-background custom-grey-border d-flex align-center"
                      >
                        <v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
                        Oops... Nothing Found.
                      </p>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <!-- Availability -->
              <v-expansion-panels>
                <!-- OPTION 1 -->
                <v-expansion-panel class="border rounded-lg">
                  <v-expansion-panel-header class="pa-4">
                    <div
                      class="d-flex align-center justify-space-between w-100"
                    >
                      <h6 class="required text-h6 font-weight-bold mb-0" style="color: red;">
                        Preferred Availability
                      </h6>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="pt-3">
                    <v-row>
                      <v-col cols="12" sm="6" class="px-1">
                        <!-- OPTION 1 -->
                        <div
                          class="pa-3"
                          style="
                            background: rgb(255, 248, 225);
                            border-radius: 8px;
                          "
                        >
                          <div class="font-weight-bold mb-2">OPTION 1</div>
                          <v-row>
                            <v-col cols="12" sm="12" class="rounded-field">
                              <v-label class="required">Date</v-label>
                              <DatePicker solo flat nullable v-model="form.date1" :error="!form.date1" />
                            </v-col>

                            <v-col cols="12" sm="12">
                              <v-label class="required">Time</v-label>
                              <TimePicker
                                class="rounded-field"
                                :value="form.time1"
                                :items="timeSlot"
                                id="time1"
                                :error="!form.time1"
                                @change="updateScheduleState('time1', $event)"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" class="px-1">
                        <!-- OPTION 2 -->
                        <div
                          class="pa-3"
                          style="
                            background: rgb(227, 242, 253);
                            border-radius: 8px;
                          "
                        >
                          <div class="font-weight-bold mb-2">OPTION 2</div>
                          <v-row>
                            <v-col cols="12" sm="12" class="rounded-field">
                              <v-label class="black--text">Date</v-label>
                              <DatePicker solo flat nullable v-model="form.date2" />
                            </v-col>

                            <v-col cols="12" sm="12">
                              <v-label class="black--text">Time</v-label>
                              <TimePicker
                                class="rounded-field"
                                :value="form.time2"
                                :items="timeSlot"
                                id="time2"
                                @change="updateScheduleState('time2', $event)"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <div class="mt-4">
                <DocumnetList
                  v-model="form.attachments"
                  :document-type="docType"
                  :disable-tags-api="true"
                />
              </div>

              <!-- Submit -->
              <v-btn
                block
                depressed
                color="cyan"
                style="border-radius: 4px !important"
                class="mt-6 white--text w-100 rounded-md"
                :loading="formLoading"
                :disabled="!form.title || isOption1Incomplete"
                @click="submitForm"
              >
                Submit Enquiry
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog -->
    <!-- Line Items Selection Dialog -->
    <LineItemDialogCustomerEnquiry
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :isType="7"
      :product-dialog="product_dialog"
      :module-type="7"
      :items="dropdownLineItems"
      :categories="lineItemCategories"
      :hide-unit-and-cost="true"
      :emit-filters="true"
      v-on:update-values="selectLineItems($event)"
      v-on:update-filters="onLineItemFilterChange($event)"
      v-on:close="product_dialog = false, product_type = 'equipment'"
    />

    <Dialog :common-dialog="action_dialog" :dialogWidth="500">
      <template v-slot:title>
        {{ action_type === "success" ? "Success" : "Error" }}
      </template>

      <template v-slot:body>
        <div class="text-center pa-4">
          <!-- Success -->
          <div v-if="action_type === 'success'">
            <img
              style="max-width: 140px"
              src="https://bthrust-fsm.s3.ap-southeast-1.amazonaws.com/ACOM0623FSM/files/image/gif/LfRf8p9jN65cXcfVTSZe7f0MKWRkQtzGP89In3Mk.gif"
            />
            <div class="mt-3 text-h6">
              {{ serverMessage }}
            </div>
          </div>

          <!-- Error -->
          <div v-else class="red--text text-h6">
            {{ serverMessage }}
          </div>
        </div>
      </template>

      <template v-slot:action>
        <v-btn color="cyan" depressed class="white--text" @click="closePage">
          OK
        </v-btn>
      </template>
    </Dialog>

    <template v-if="validationErrorBag.length">
      <v-snackbar
        :timeout="5000"
        :value="true"
        top
        color="error"
        right
        v-for="(error, index) in validationErrorBag"
        :key="index"
      >
        {{ error }}
      </v-snackbar>
    </template>
  </v-app>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import TimePicker from "@/view/components/TimePicker.vue";
import DocumnetList from "@/view/pages/DocumnetList";
import LineItemDialogCustomerEnquiry from "@/view/components/LineItemDialogCustomerEnquiry.vue";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import { GET, POST_PUBLIC } from "@/core/services/store/request.module";
import { ErrorEventBus,InitializeError } from "@/core/lib/message.lib";

export default {
  created() {
    this.getConfiguration();
    this.getCustomerData();
    ErrorEventBus.$on("update:error", (error) => {
      if (Array.isArray(error)) {
        this.validationErrorBag = [...this.validationErrorBag, ...error];
      } else {
        this.validationErrorBag.push(error);
      }
    });
  },

  beforeDestroy() {
    ErrorEventBus.$off("update:error");
  },
  name: "customer-enquiry",

  components: { Dialog, DatePicker, TimePicker, DocumnetList, LineItemDialogCustomerEnquiry, TinyMCE },

  data() {
    return {
      companyLogo: '',
      customer: {
        name: "",
        email: "",
        phone: "",
      },
      enquiryMeta: {
        billing: null,
        billing_contact_person: null,
        customer: null,
        property: null,
        property_contact_person: null,
      },
      lineItems: [],
      dropdownLineItems: [],
      selectedLineItems: [],
      lineItemCategories: [],
      lineItemFilters: {
        search: null,
        category: null,
        alphabet: null,
      },
      product_dialog: false,
      product_type: "equipment",
      dialog_key: Number(new Date()),
      panel: [0],
      docType: 51,
      formLoading: false,
      action_dialog: false,
      action_type: null,
      validationErrorBag: [],
      serverMessage: "",
      timeSlot: [
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
      ],

      form: {
        title: "",
        description: "",
        problem: "",
        date1: null,
        time1: null,
        date2: null,
        time2: null,
        attachments: [],
      },
      priority:2,
      impact:2,
    };
  },

  computed: {
    isCustomerType() {
      return (this.$route?.query?.type || "") === "customer";
    },
    isOption1Incomplete() {
      return !this.form.date1 || !this.form.time1;
    },
  },

  methods: {
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getCustomerData(filters = null) {
      const token = this.$route?.query?.token || '';
      const type = this.$route?.query?.type || '';
      if (!token) return Promise.resolve(null);
      let url = `/getCustomerData?token=${encodeURIComponent(token)}&type=${encodeURIComponent(type)}`;
      if (filters) {
        if (filters.search) url += `&search=${encodeURIComponent(filters.search)}`;
        if (filters.category && filters.category !== 'all') url += `&category=${encodeURIComponent(filters.category)}`;
        if (filters.alphabet && filters.alphabet !== 'all') url += `&alphabet=${encodeURIComponent(filters.alphabet)}`;
      }
      return this.$store
        .dispatch(GET, {
          url: url,
        })
        .then((data) => {
          if (data && data.data) {
            const payload = data.data;
            const equipment = payload?.equipments?.[0] || {};
            const toId = (value) => {
              if (value && typeof value === "object") return value.id || null;
              return value || null;
            };
            const getContactPersonId = (container) => {
              const contactPerson = container?.contact_person;
              if (contactPerson && typeof contactPerson === "object") {
                return contactPerson.id || null;
              }
              return contactPerson || null;
            };

            const billing = payload?.billing || null;
            const property = payload?.property || equipment?.property || billing || null;
            const billingId = toId(billing);
            const propertyId = toId(property);
            const billingContactPerson = getContactPersonId(billing);
            const propertyContactPerson =
              getContactPersonId(payload?.property) ||
              getContactPersonId(property) ||
              null;

            this.enquiryMeta = {
              billing: billingId,
              billing_contact_person: billingContactPerson || null,
              customer:
                payload?.customerId ||
                equipment?.customer?.id ||
                (billing && typeof billing === "object" ? billing?.customer : null) ||
                null,
              property: propertyId,
              property_contact_person: propertyContactPerson || null,
            };

            this.customer = {
              name: equipment.customer?.default_person?.full_name || '-',
              email: equipment.customer?.default_person?.primary_email || '-',
              phone: equipment.customer?.default_person?.primary_phone || '-',
            };
            this.lineItems = payload.line_items || [];
            this.dropdownLineItems = payload.line_items || [];
            // Extract categories from API
            if (payload.categories && Array.isArray(payload.categories)) {
              this.lineItemCategories = payload.categories;
            }
            if (!filters) {
              this.selectedLineItems = [];
            }
            return payload;
          }
          return null;
        })
        .catch(() => {
          this.enquiryMeta = {
            billing: null,
            billing_contact_person: null,
            customer: null,
            property: null,
            property_contact_person: null,
          };
          this.customer = { name: '-', email: '-', phone: '-' };
          this.lineItems = [];
          this.dropdownLineItems = [];
          this.lineItemCategories = [];
          this.selectedLineItems = [];
          return null;
        });
    },
    getConfiguration() {
      this.$store
        .dispatch(GET, { url: `/configuration` })
        .then((data) => {
          if (data && data.data && data.data.company_logo) {
            this.companyLogo = data.data.company_logo;
          } else {
            this.companyLogo = 'No logo found';
          }
        })
        .catch(() => {
          this.companyLogo = 'No logo found';
        });
    },
    closePage() {
      // Only close the form/page if the action_type is 'success'.
      if (this.action_type === 'success') {
        try {
          window.open("", "_self");
        } catch (e) {
          // ignore
        }
        try {
          window.close();
        } catch (e) {
          // ignore
        }
        try {
          self.close();
        } catch (e) {
          // ignore
        }
        try {
          top.close();
        } catch (e) {
          // ignore
        }
        setTimeout(() => {
          if (!window.closed) {
            window.location.replace("about:blank");
          }
        }, 150);
      } else {
        // Just close the dialog if not success
        this.action_dialog = false;
      }
    },
    manageLimit(e, field) {
      if (this.form[field] && this.form[field].length >= 100) {
        e.preventDefault();
      }
    },

    onPaste(e, field) {
      const pastedText = e.clipboardData.getData("text");
      const currentValue = this.form[field] || "";

      const finalValue = currentValue + pastedText;

      if (finalValue.length > 100) {
        this.form[field] = finalValue.substring(0, 100);
        e.preventDefault();
      }
    },
    updateScheduleState(key, value) {
      this.form[key] = value;
    },

    getLineItemLabel(item) {
      if (typeof item?.product === "string" && item.product.trim()) {
        return item.product;
      }
      if (item?.product?.name) {
        return item.product.name;
      }
      return (
        item?.product_name ||
        item?.name ||
        item?.description ||
        "Product"
      );
    },

    removeLineItem(index) {
      this.selectedLineItems.splice(index, 1);
    },

    selectLineItems(items) {
      console.log('LineItemDialogCustomerEnquiry returned items:', items);
      console.log('dropdownLineItems available:', this.dropdownLineItems);
      if (!Array.isArray(items)) {
        items = [items];
      }
      for (let item of items) {
        const exists = this.selectedLineItems.find(
          (selected) => selected.product_id === item.product_id
        );
        if (exists) {
          Object.assign(exists, {
            ...item,
            quantity: item.quantity || exists.quantity || 1,
          });
        } else {
          this.selectedLineItems.push({
            ...item,
            quantity: item.quantity || 1,
            _expanded: false,
            description: item.description || "",
          });
        }
      }
      this.product_dialog = false;
    },

    onLineItemFilterChange(filters) {
      console.log('Filter changed:', filters);
      this.lineItemFilters = { ...filters };
      this.getCustomerData(filters);
    },

    async submitForm() {
      // Dynamic required field validation
      const missingFields = [];
      if (!this.form.title) missingFields.push('Title');
      if (!this.form.date1) missingFields.push('Date (Option 1)');
      if (!this.form.time1) missingFields.push('Time (Option 1)');
      if (missingFields.length > 0) {
        this.serverMessage = `Please fill in the following required field${missingFields.length > 1 ? 's' : ''}: ${missingFields.join(', ')}`;
        this.action_type = 'error';
        this.action_dialog = true;
        return;
      }
      this.formLoading = true;
      try {
        const lineItemsPayload = this.isCustomerType
          ? this.selectedLineItems
          : this.lineItems;
        const request = {
          title: this.form.title,
          description: this.form.description,
          problem: this.form.problem,
          first_available_date: this.form.date1 || '',
          first_available_time: this.form.time1 || '',
          second_available_date: this.form.date2 || '',
          second_available_time: this.form.time2 || '',
          priority: this.priority,
          impact: this.impact,
          billing: this.enquiryMeta.billing || '',
          billing_contact_person: this.enquiryMeta.billing_contact_person || '',
          customer: this.enquiryMeta.customer || '',
          date: this.getCurrentDate(),
          property: this.enquiryMeta.property || '',
          property_contact_person: this.enquiryMeta.property_contact_person || '',
          attachments: this.form.attachments,
          is_line_items: lineItemsPayload.length > 0,
          "line-item": lineItemsPayload,
          calculation: {
            discount_type: 1,
            discount_value: null,
            tax_active: true,
            adjustment: 0,
            collected_amount: "0.00",
            discount_level: "transaction",
            show_price: false,
            tax_value: 9,
            total_non_text_amount: 0,
            visit_amount: "0.00"
          },
        };

        await this.$store.dispatch(POST_PUBLIC, {
          url: '/newEnquiry',
          data: request,
        });

        this.serverMessage = 'Thank you! Your enquiry submitted successfully.';
        this.action_type = 'success';
        this.action_dialog = true;
        this.resetForm();
      } catch (err) {
        let message = 'Something went wrong';
        if (err && err.status === 404) {
          message = '❌ API Not Found (404)';
        } else if (err && err.status === 500) {
          message = '❌ Server Error (500)';
        } else if (err && err.data && err.data.message) {
          message = err.data.message;
        }
        ErrorEventBus.$emit("update:error", InitializeError(message));
      } finally {
        this.formLoading = false;
      }
    },

    resetForm() {
      this.form = {
        title: "",
        description: "",
        problem: "",
        date1: null,
        time1: null,
        date2: null,
        time2: null,
        attachments: [],
      };
      this.selectedLineItems = [];
      this.dropdownLineItems = [];
    },
  },
};
</script>

<style scoped>
.header-details {
  border-bottom: 1px solid #e5e7eb;
}

.customer-info {
  text-align: right;
}

.customer-name {
  font-weight: 600;
  font-size: 16px;
}

.customer-meta {
  font-size: 13px;
  color: #6b7280;
}

.border {
  border: 1px solid #e5e7eb;
}

.border-bottom {
  border-bottom: 1px solid #e5e7eb;
}

.custom-grey-border {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.color-custom-blue {
  color: #24326d;
}

.selected-asset-label {
  color: #000;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 0;
}

.line-item-list {
  overflow: visible;
}

.line-item-qty-label {
  white-space: nowrap;
}

.line-item-title-main {
  width: 100%;
  min-width: 0;
}

.line-item-meta-mobile {
  display: none;
}

.line-item-actions-mobile {
  display: none;
  flex-shrink: 0;
  margin-left: auto;
}

.rounded {
  border-radius: 10px;
}

.upload-box {
  border: 1px dashed #ccc;
  background-color: #ffffff;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.required::after {
  content: " *";
  color: red;
}

.v-expansion-panel-header {
  background: #f9fafb;
  border-radius: 10px;
}

.v-expansion-panel {
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.v-card {
  border-radius: 10px;
}

:deep(.v-text-field.rounded-field .v-input__slot),
:deep(.v-text-field--solo.v-text-field--rounded .v-input__slot),
:deep(.rounded-field .v-text-field .v-input__control .v-input__slot) {
  border-radius: 4px !important;
}

:deep(.rounded-field .v-input__slot) {
  border-radius: 14px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel:not(:first-child)::after {
  border-color: transparent !important;
}

@media (max-width: 600px) {
  .line-item-title-cell,
  .line-item-qty,
  .line-item-actions-desktop,
  .line-item-header-text {
    width: 100% !important;
  }

  .line-item-row {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .line-item-row > div[style*="width: 65%"],
  .line-item-row > div[style*="width: 20%"],
  .line-item-row > div[style*="width: 15%"] {
    width: 100% !important;
  }

  .line-item-title-cell {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }

  .line-item-title-main {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: 4px;
  }

  .line-item-actions-mobile {
    display: flex !important;
    align-items: center;
    margin-left: auto;
    flex-shrink: 0;
  }

  .line-item-meta-desktop,
  .line-item-actions-desktop {
    display: none !important;
  }

  .line-item-meta-mobile {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .line-item-qty-label {
    font-size: 12px;
  }

  .line-item-qty {
    padding-top: 4px;
  }

  .line-item-qty :deep(.v-input__slot) {
    margin-bottom: 0;
  }

  .line-item-qty :deep(.v-text-field) {
    margin-top: 0;
  }
}
</style>